/**
 * Blueprint metadata `traits[].type` / `traits[].name` values used in guards and search.
 * Distinct from catalog filter keys (`FILTER_TYPES.CATEGORY`) and search chip keys (`SEARCH_CHIP_KEYS.CATEGORY`).
 */

import type { Traits } from "@/lib/sparxs/metadataSchemas";

export const TRAIT_TYPE_CATEGORY = "category" as const;

const TRAIT_TYPE_ADDON = "addon" as const;
const TRAIT_NAME_REACTIONS = "reactions" as const;

export const isCategoryTraitType = (type: string): boolean =>
  type.trim() === TRAIT_TYPE_CATEGORY;

const matchesReactionsAddonTrait = (
  type: string,
  name: string | undefined,
): boolean => {
  const normalizedType = type.trim().toLowerCase();
  const normalizedName =
    typeof name === "string" ? name.trim().toLowerCase() : "";
  return (
    normalizedType === TRAIT_TYPE_ADDON &&
    normalizedName === TRAIT_NAME_REACTIONS
  );
};

export const findReactionsAddonTrait = (
  traits: Traits[] | undefined,
): Traits | undefined => {
  if (traits == null || traits.length === 0) {
    return undefined;
  }
  return traits.find((trait) =>
    matchesReactionsAddonTrait(trait.type, trait.name),
  );
};
